export default function CaseStudiesSection() {
  const cases = [
    {
      icon: 'ri-ship-line',
      industry: 'Международная логистика',
      desc: 'Комплексное сопровождение отдела продаж с разбором реальных сделок и переговоров.',
      metrics: [
        { value: '18–23%', label: 'рост конверсии месяц к месяцу' },
        { value: '+20%', label: 'в среднем за период сопровождения' }
      ]
    },
    {
      icon: 'ri-global-line',
      industry: 'Консьерж-сервис',
      desc: '4-недельный онлайн-курс по работе с ценностью и продлениями.',
      metrics: [
        { value: '64→84%', label: 'рост продлений' },
        { value: '×9', label: 'рост длительных оплат' }
      ]
    },
    {
      icon: 'ri-building-4-line',
      industry: 'Агентство недвижимости',
      desc: 'Бизнес-игры, практикумы и совместные звонки реальным клиентам.',
      metrics: [
        { value: '×2', label: 'договоров по холодным звонкам' }
      ]
    },
    {
      icon: 'ri-shopping-bag-3-line',
      industry: 'B2C, товары из Китая',
      desc: 'Серия тренингов и 3 месяца корпоративного сопровождения.',
      metrics: [
        { value: '+55%', label: 'рост конверсии месяц к месяцу' },
        { value: '116 000 $', label: 'прирост валовой прибыли' }
      ]
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Кейсы: реальные результаты
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Цифры, за которыми стоит системная работа. Каждый кейс — это диагностика, обучение и сопровождение команды.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cases.map((c, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 md:p-7 hover:shadow-md transition-all duration-300 group cursor-default flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${c.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 leading-tight">{c.industry}</h3>
              </div>

              <p className="text-sm text-gray-600 leading-relaxed mb-5 flex-1">{c.desc}</p>

              <div className="space-y-3">
                {c.metrics.map((m, j) => (
                  <div key={j} className="flex items-baseline gap-2">
                    <span className="text-xl font-extrabold text-teal-600">{m.value}</span>
                    <span className="text-sm text-gray-600">{m.label}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}